module.exports = __webpack_public_path__ + "img/couples-065.5f7c35a2.jpg";